import React from 'react';
import { useParams } from 'react-router-dom';
import EditLink from '../../shared/components/EditLink';
import CourseOutline from './CourseOutline';
import { useCourse } from './useCourse';
import './style/course.scss';

export default function Course() {
  const { courseId } = useParams();
  const { course, loading, error } = useCourse(courseId);
  return (
    <main className="course">
      {loading && <p><output>Loading course…</output></p>}
      {error && <p role="alert">{error}</p>}
      {course && <>
        <header className="course__header"><h1>{course.title}</h1>
          <EditLink to={`/editor/course/${courseId}/edit`} label="Edit course" /></header>
        {course.description && <p className="course__description">{course.description}</p>}
        <CourseOutline course={course} courseId={courseId} />
      </>}
    </main>
  );
}
